<template>
    <div class="flex flex-col md:flex-row">
        <div
            class="flex flex-none flex-col bg-black p-8 text-white md:min-h-[300px] md:w-[20rem] md:max-w-[20rem]"
        >
            <div class="text-gray-600">Topic</div>
            <div class="text-[28px] font-semibold leading-snug">
                {{ stackTitle }}
            </div>
            <div class="my-auto border-b border-white/10"></div>
            <div class="flex justify-between">
                <div class="">
                    <div class="text-[14px] text-gray-600"># of Cards</div>
                    <div class="">{{ flashcards.length }}</div>
                </div>
                <div class="">
                    <div class="text-[14px] text-gray-600">Creator</div>
                    <div class="flex items-center gap-2">
                        <div class="">EMTprep</div>
                        <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M10.6485 1.73886C11.4132 1.03792 12.5868 1.03792 13.3515 1.73886L15.5641 3.76711C15.8543 4.03314 16.2166 4.2076 16.6055 4.26863L19.5708 4.73392C20.5955 4.89472 21.3273 5.8123 21.256 6.84715L21.0498 9.84163C21.0228 10.2344 21.1122 10.6264 21.307 10.9685L22.7921 13.577C23.3053 14.4784 23.0441 15.6227 22.1906 16.2122L19.7209 17.918C19.3969 18.1417 19.1462 18.4561 19.0002 18.8217L17.8867 21.6091C17.5019 22.5724 16.4445 23.0816 15.4515 22.7818L12.5779 21.9145C12.201 21.8007 11.799 21.8007 11.4221 21.9145L8.54854 22.7818C7.55549 23.0816 6.49809 22.5724 6.11329 21.6091L4.99983 18.8217C4.85378 18.4561 4.60308 18.1417 4.27914 17.918L1.80939 16.2122C0.955879 15.6227 0.694721 14.4785 1.20793 13.577L2.69298 10.9685C2.88776 10.6264 2.97724 10.2344 2.95019 9.84163L2.74398 6.84715C2.67271 5.8123 3.40446 4.89472 4.42922 4.73392L7.39451 4.26863C7.78344 4.2076 8.14572 4.03314 8.43594 3.76711L10.6485 1.73886Z"
                                fill="#02BBEA"
                            />
                            <path
                                d="M7.57892 13.105C8.83539 13.5238 10.762 14.0264 11.7672 16.0367C12.7444 13.3842 14.2801 9.33557 16.3742 8.0791"
                                stroke="white"
                                stroke-width="1.67529"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="flex h-full min-h-[300px] w-full select-none flex-col justify-center bg-white p-8 py-16 text-gray-900"
        >
            <div class="w-full" v-if="activeFlashcardIndex < flashcards.length">
                <div
                    class="text-center text-[20px] font-semibold leading-relaxed"
                >
                    {{ flashcards[activeFlashcardIndex].front }}
                </div>
                <div class="my-8 w-full border-b border-black/10"></div>
                <div class="mb-16 flex justify-center">
                    <div
                        class="btn btn-primary !border-black !bg-black text-white"
                        v-if="hideAnswer"
                        @click="hideAnswer = false"
                    >
                        Show Answer
                    </div>
                    <div
                        class="py-2 text-center text-[18px] leading-relaxed"
                        v-else
                    >
                        {{ flashcards[activeFlashcardIndex].back }}
                    </div>
                </div>
                <div class="leading-0 mt-auto flex justify-center gap-8">
                    <div
                        class="flex h-8 w-8 items-center rounded border border-gray-325 text-center text-center text-[20px] font-semibold hover:cursor-pointer hover:bg-gray-325"
                        @click="prevFlashcard"
                    >
                        <div class="flex w-full items-center justify-center">
                            <div
                                :class="
                                    activeFlashcardIndex === 0
                                        ? 'text-gray-500'
                                        : 'text-gray-700'
                                "
                            >
                                <svg
                                    width="6"
                                    height="12"
                                    viewBox="0 0 6 12"
                                    fill="none"
                                    stroke="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M5.25 10.5L0.75 6L5.25 1.5"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="w-24 text-center text-gray-600">
                        {{ activeFlashcardIndex + 1 }} of
                        {{ flashcards.length }}
                    </div>
                    <div
                        class="flex h-8 w-8 items-center rounded border border-gray-325 text-center text-center text-[20px] font-semibold hover:cursor-pointer hover:bg-gray-300"
                        @click="nextFlashcard"
                    >
                        <div
                            class="flex w-full items-center justify-center text-gray-700"
                        >
                            <svg
                                width="6"
                                height="12"
                                viewBox="0 0 6 12"
                                fill="none"
                                stroke="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M0.75 10.5L5.25 6L0.75 1.5"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col items-center justify-center gap-4" v-else>
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="12" cy="12" r="12" fill="#0B8753" />
                    <path
                        d="M6.66699 12.5337C8.72547 13.9559 11.7196 16.0537 11.7196 17.3337C12.6553 14.1337 15.088 7.52033 17.3337 6.66699"
                        stroke="white"
                        stroke-width="2"
                    />
                </svg>
                <div class="text-center text-[24px] font-semibold">
                    All done — great job!
                </div>
                <div
                    class="flex flex-col items-center justify-center rounded bg-gray-200 p-8"
                >
                    <div class="mb-4 text-center leading-loose">
                        Our all-inclusive membership gives you access to 400+
                        flashcard decks across all categories tested on the
                        NREMT
                    </div>
                    <Link
                        class="btn btn-primary btn-lg"
                        :href="route('frontend.pricing')"
                        >Get started for $39/month
                    </Link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FrontendFlashcardStack",
    data() {
        return {
            stackTitle: "Coronary Artery Disease",
            flashcards: [
                {
                    front: "____ refers to fatty plaque buildup within the wall of a coronary artery",
                    back: "Atherosclerosis",
                },
                {
                    front: "Narrowing of a blood vessel can also be referred to as ____",
                    back: "Stenosis",
                },
                {
                    front: "During which phase of contraction are the coronary arteries perfused?",
                    back: "Diastole",
                },
                {
                    front: "Myocardial infarction caused by a complete occlusion of a coronary artery that results in ST segment elevation?",
                    back: "STEMI",
                },
                {
                    front: "Ischemic chest pain that occurs at rest without ECG or cardiac enzyme changes",
                    back: "Unstable angina",
                },
                {
                    front: "Which coronary artery supplies the inferior wall of the heart and the right ventricle?",
                    back: "Right coronary artery (RCA)",
                },
                {
                    front: "Which coronary artery supplies the anterior wall of the heart?",
                    back: "Left anterior descending (LAD)",
                },
                {
                    front: "Which coronary artery supplies the lateral wall of the left ventricle?",
                    back: "Left circumflex (LCX)",
                },
                {
                    front: "What is the most important piece of information to identify a STEMI?",
                    back: "12 lead ECG",
                },
                {
                    front: "What does ST segment depression on an ECG represent in the context of ischemic chest pain?",
                    back: "Subendocardial ischemia",
                },
                {
                    front: "This STEMI mimic is the result of inflammation of the pericardium and may result in widespread, concave ST elevation. ",
                    back: "Pericarditis",
                },
                {
                    front: "What treatment is standard of care for STEMI (in the hospital)?",
                    back: "Percutaneous intervention (PCI)",
                },
                {
                    front: "Signs of myocardial ischemia other than chest pain are known as ______",
                    back: "Anginal equivalents",
                },
                {
                    front: "_______ is a blanket term that includes unstable angina, STEMI, and NSTEMI",
                    back: "Acute Coronary Syndrome",
                },
                {
                    front: "Treatments for ischemic chest pain: ",
                    back: "Aspirin, nitroglycerin, oxygen if needed, narcotic analgesics",
                },
                {
                    front: "Leads II, III, and aVF look at the ____ wall of the heart ",
                    back: "Inferior",
                },
                {
                    front: "Death of heart tissue due to ischemia",
                    back: "Infarction",
                },
                {
                    front: "1 mm or more of ST elevation in ____ contiguous limb leads is positive for STEMI",
                    back: "2 or more",
                },
                {
                    front: "Cariogenic pulmonary edema is most likely to be the result of ___ ventricular infarct",
                    back: "Left",
                },
                {
                    front: "Criteria to identify STEMI in the presence of LBBB",
                    back: "Sgarbossa",
                },
            ],
            activeFlashcardIndex: 0,
            hideAnswer: true,
        };
    },
    methods: {
        prevFlashcard() {
            this.hideAnswer = true;
            this.activeFlashcardIndex > 0 ? this.activeFlashcardIndex-- : null;
        },
        nextFlashcard() {
            this.hideAnswer = true;
            this.activeFlashcardIndex = this.activeFlashcardIndex + 1;
        },
    },
};
</script>

<style scoped></style>
